var _rect, _path, _path2, _path3, _ellipse, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatabaseError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 96,
  height: 96,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 96,
  fill: "#F3F3F4",
  rx: 48
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#92999E",
  strokeWidth: 1.25,
  d: "M48 63c6.627 0 12-1.085 12-2.423V54.5a2 2 0 0 0-2-2H38a2 2 0 0 0-2 2v6.077C36 61.915 41.373 63 48 63Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#92999E",
  strokeWidth: 1.25,
  d: "M48 54c6.627 0 12-1.085 12-2.423V45.5a2 2 0 0 0-2-2H38a2 2 0 0 0-2 2v6.077C36 52.915 41.373 54 48 54Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#92999E",
  strokeWidth: 1.25,
  d: "M48 45c6.627 0 12-1.085 12-2.423V34.65a.15.15 0 0 0-.15-.15h-23.7a.15.15 0 0 0-.15.15v7.927C36 43.915 41.373 45 48 45Z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 48,
  cy: 34.5,
  fill: "#fff",
  stroke: "#92999E",
  strokeWidth: 1.25,
  rx: 12,
  ry: 1.5
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#E67D2D",
  d: "M58.293 50.793c.78-1.277 2.634-1.277 3.414 0l7.433 12.164C69.955 64.29 68.996 66 67.434 66H52.566c-1.562 0-2.52-1.71-1.706-3.043l7.433-12.164Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M60 56v3"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 61.75,
  r: 0.75,
  fill: "#fff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatabaseError);
export default ForwardRef;